import * as Sentry from '@sentry/nextjs';

import { DeviceCheckResult } from '~/generated/graphql';
import getBatteryManager from '~/helpers/deviceChecks/getBatteryManager';
import { DeviceCheckMetadata } from '~/types';

const checkBatteryLevel: DeviceCheckMetadata['check'] = async ({
  expectedValue,
  registrationDetails,
}) => {
  try {
    if (!expectedValue) {
      throw new Error('Expected value not provided');
    }

    const batteryManager = await getBatteryManager();

    // For timing out the check
    // const batteryManager = await checkTimeOut(
    //   getBatteryManager(),
    //   'Battery fetch timed out',
    // );

    if (!batteryManager) {
      throw new Error('Battery manager not available');
    }

    const expectedBatteryLevel = parseInt(expectedValue, 10);
    const batteryLevel = batteryManager.level * 100;
    const reportedBatteryLevel = Math.round(batteryLevel).toString();
    const isCharging = batteryManager.charging;

    if (
      !Number.isNaN(expectedBatteryLevel) &&
      (isCharging || batteryLevel >= expectedBatteryLevel)
    ) {
      return {
        expectedValue,
        result: DeviceCheckResult.Pass,
        value: reportedBatteryLevel,
      };
    }
    return {
      expectedValue,
      result: DeviceCheckResult.Fail,
      value: reportedBatteryLevel,
    };
  } catch (err) {
    const e = err as Error;
    const error = new Error(
      JSON.stringify({
        error: e.message,
        registrationDetails,
      }),
    );

    Sentry.captureException(error);
    return {
      expectedValue,
      result: DeviceCheckResult.Fail,
      value: e.message,
    };
  }
};

export default checkBatteryLevel;
